import { render, staticRenderFns } from "./BioSignup.vue?vue&type=template&id=11a866e3&scoped=true&"
import script from "./BioSignup.vue?vue&type=script&lang=js&"
export * from "./BioSignup.vue?vue&type=script&lang=js&"
import style0 from "./BioSignup.vue?vue&type=style&index=0&id=11a866e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a866e3",
  null
  
)

export default component.exports